module.exports = __webpack_public_path__ + "static/media/Sec-3_2677_Background.9ca0233b.webp";